import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftCardQuery = createQueryHook(GiftCardsApiClient.getGiftCard, {
  queryKey: ['giftCard'],
})
